// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1w9G0","requiredAsterisk":"Info_requiredAsterisk__QqoHY"};